export default __webpack_public_path__ + "static/media/goods15.c84d594e.png";